import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { StatusCodes } from 'http-status-codes';
import { ProductWithQuantitiesGetDto } from 'svila-common';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import OrdersApi from '../../../../services/api/OrdersApi';
import SecondaryNavigation from '../../../../components/common/navigation/SecondaryNavigation';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import DisplayLocation from '../../../../components/common/DisplayLocation';
import DisplayQuantities from '../../../../components/common/DisplayQuantities';
import DisplayDate from '../../../../components/common/DisplayDate';
import InventoryApi from '~/src/services/api/InventoryApi';
import ProductService from '~/src/services/logic/ProductService';
import TableWrapper from '~/src/components/common/forms/TableWrapper/TableWrapper';

export default function OrderEdit(): JSX.Element {
  const { id, consolidation } = useParams();
  const history = useHistory();
  const [itemData, setItemData] = useState<ProductWithQuantitiesGetDto[] | null>(null);

  const getItem = async (): Promise<void> => {
    const res = await InventoryApi.getReserved(id);
    if (res.status === StatusCodes.OK) {
      setItemData(res.data);
    }
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <WhitePad isFluid>
      <SecondaryNavigation isConsolidation={consolidation} />

      <TitleComponent
        title="Printout"
        onLeftHandler={(): void => {
          history.push('/orders-list');
        }}
      />
      <CompanyWrapper>
        <h1>{itemData?.[0]?.quantities?.[0].sellOrder?.customer?.name}</h1>
        <p>{itemData?.[0]?.quantities?.[0].sellOrder?.orderNumber}</p>
      </CompanyWrapper>

      <div style={{ width: '100%' }}>
        <TableWrapper>
          <thead>
            <tr>
              <HeaderCell>#</HeaderCell>
              <HeaderCell>Локация - Бройка - Дата - Партида</HeaderCell>
              <HeaderCell>Име На Продукт</HeaderCell>
              <HeaderCell>{`на Кашон \n на Дисплеи \n на Единица`}</HeaderCell>
              <HeaderCell>
                Поръчано
                <br />
                количество
              </HeaderCell>
              <HeaderCell>Редове</HeaderCell>
            </tr>
          </thead>
          <TBodyStyles>
            {itemData?.map((item, index) => {
              const duSum = item.quantities.reduce((sum, curr) => {
                return sum + (curr.fullDuUnits ?? 0);
              }, 0);
              const dpSum = item.quantities.reduce((sum, curr) => {
                return sum + (curr.singleDpUnits ?? 0);
              }, 0);
              const cuSum = item.quantities.reduce((sum, curr) => {
                return sum + (curr.singleCuUnits ?? 0);
              }, 0);
              return (
                <TrStyle key={item.product.id}>
                  <Cell disabled>{`#${index + 1}`}</Cell>
                  <Cell align="left">
                    {item?.quantities?.map((info) => {
                      return (
                        <div key={info.tempId} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                          <DisplayLocation
                            chamber={info.warehouseLocation.warehouseChamber.number}
                            column={info.warehouseLocation.column}
                            letter={info.warehouseLocation.letter}
                            level={info.warehouseLocation.level}
                          />
                          {'  '}
                          <DisplayQuantities
                            duQuantity={info.fullDuUnits}
                            dpQuantity={info.singleDpUnits}
                            cuQuantity={info.singleCuUnits}
                          />
                          {'  '}
                          <DisplayDate date={info.expirationDate} />
                          {`  ${info.lot ?? ''} `}
                        </div>
                      );
                    })}
                  </Cell>
                  <Cell align="left">
                    {item.product.genericProduct.name}
                    <br />[{item?.orderProduct?.placement}] [{item?.orderProduct?.sample}] [
                    {item?.orderProduct?.label?.name}]
                  </Cell>
                  <Cell>
                    <div>{ProductService.getDuGtin(item.product.packagedProducts) || '------'}</div>
                    <div>{ProductService.getDisplayGtin(item.product.packagedProducts) || '------'}</div>
                    <div>
                      <b>{ProductService.getCuGtin(item.product.packagedProducts) || '------'}</b>
                    </div>
                  </Cell>
                  <Cell>
                    <DisplayQuantities duQuantity={duSum} dpQuantity={dpSum} cuQuantity={cuSum} />
                  </Cell>
                  <Cell disabled>
                    <CellRow>
                      <div>
                        <DisplayQuantities
                          vertical
                          // duQuantity={item.leftoverDu}
                          // dpQuantity={item.leftoverDp}
                          // cuQuantity={item.leftoverCu}
                        />
                      </div>
                      <div style={{ paddingLeft: 30, fontSize: 26, fontWeight: 'bold' }}>
                        {/* {`Цели: ${item.layersCount ? item.layersCount : 0}`} */}
                      </div>
                    </CellRow>
                  </Cell>
                </TrStyle>
              );
            })}
          </TBodyStyles>
        </TableWrapper>
      </div>
    </WhitePad>
  );
}

const CompanyWrapper = styled.div`
  background: #f4f4f4;
  width: 100%;
  border-radius: 10px;
  padding: 30px 20px 10px 20px;
  margin-bottom: 25px;

  h1 {
    color: #343434;
    font-size: 25px;
    text-align: center;
    padding: 0;
    margin-bottom: 10px;
  }
  p {
    color: #a7a7a7;
    font-size: 25px;
    text-align: center;
  }
`;

interface CellProps {
  disabled?: boolean;
  align?: 'center' | 'left' | 'right';
}

const Cell = styled.td<CellProps>`
  padding: 5px;
  white-space: pre-line;
  text-align: ${(props): string => (props.align ? props.align : 'center')};
  &:first:child {
    display: flex;
    flex-direction: column;
  }
`;

const HeaderCell = styled.th`
  padding: 5px;
  border-bottom: 2px solid #6e6e6e;
  font-weight: bold;
  white-space: pre-line;
  text-align: center;
`;

const CellRow = styled.div`
  flex-direction: row;
  display: flex;
`;

const TrStyle = styled.tr`
  border-bottom: 1px solid #6e6e6e;
`;

const TBodyStyles = styled.tbody`
  ${TrStyle}:nth-child(even) {
  }
`;
